import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import { withStyles } from '@material-ui/styles';

import { showSnackbarMessage } from '../../modules/actions/layout';
import { readEndpointAllPages } from '../../modules/reducers/api';

import RideEdit from './RideEdit';
import RideRow from './RideRow';
import {
  FixedWidthTable,
  FlexTableRow,
  FabTableCell, MileageTableCell, RideTableCell, RouteBlockageTableCell,
} from './TableTools';

import { selectActiveRides, selectRideAdminOptions } from './selectors';

const styles = {
  container: {
    minHeight: '250px',
    overflow: 'hidden auto',
    width: '100%',
  },
  loadingIndicator: {
    display: 'block',
    margin: '0 auto',
  },
};

const RideAdminActiveList = ({
  detailOptions, rides, // state props
  readEndpointAllPages, showSnackbarMessage, // dispatch props
  classes, // withStyles props
}) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    readEndpointAllPages('ride?page_size=50&filter[distance_depot_end__isnull]=True&include=routeblockage,driver,vehicle')
      .catch((error) => {
        console.error(`[TVV] RideAdminActiveList retrieval of all open rides failed: ${error}`);
        console.error(error);

        showSnackbarMessage('Er is iets foutgegaan bij het ophalen van actieve ritten!');
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className={classes.container}>
      <FixedWidthTable size="small">
        <TableHead>
          <FlexTableRow>
            <RouteBlockageTableCell>Stremming</RouteBlockageTableCell>
            <RideTableCell>Rit</RideTableCell>
            <MileageTableCell>Standen</MileageTableCell>
            <FabTableCell />
          </FlexTableRow>
        </TableHead>

        <TableBody>
          {!loading && rides.map(ride => <RideRow key={`ride-${ride.id}`} ride={ride} />)}
        </TableBody>
      </FixedWidthTable>

      {loading && <CircularProgress size={80} classes={{ root: classes.loadingIndicator }} />}

      <RideEdit
        open={detailOptions !== undefined}
        options={detailOptions}
      />
    </div>
  );
};

RideAdminActiveList.propTypes = {
  // state props
  detailOptions: PropTypes.shape({}),
  rides: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['ride']).isRequired,
    id: PropTypes.string.isRequired,
  })).isRequired,

  // dispatch props
  readEndpointAllPages: PropTypes.func.isRequired,
  showSnackbarMessage: PropTypes.func.isRequired,

  // withStyles props
  classes: PropTypes.object.isRequired,
};

RideAdminActiveList.defaultProps = {
  detailOptions: undefined,
};

const mapStateToProps = state => ({
  detailOptions: selectRideAdminOptions(state),
  rides: selectActiveRides(state),
});

const mapDispatchToProps = {
  readEndpointAllPages,
  showSnackbarMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RideAdminActiveList));
